import { render, staticRenderFns } from "./BlockContentButtons.vue?vue&type=template&id=76d2ef6c"
import script from "./BlockContentButtons.vue?vue&type=script&lang=js"
export * from "./BlockContentButtons.vue?vue&type=script&lang=js"
import style0 from "./BlockContentButtons.vue?vue&type=style&index=0&id=76d2ef6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports